import { createFileRoute } from "@tanstack/react-router";

import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { SystemLabels } from "@/lib/labels/system";

import { AuditSection } from "./-components/audit-section";
import { DecisionsSection } from "./-components/decisions-section";
import { DocumentFieldsSection } from "./-components/document-fields-section";
import { DocumentPoliciesSection } from "./-components/document-policies-section";
import { DocumentProfileSection } from "./-components/document-profile-section";
import { EtlSection } from "./-components/etl-section";
import { GuidanceSection } from "./-components/guidance-section";
import { IntegrationsSection } from "./-components/integrations-section";
import { JobsSection } from "./-components/jobs-section";
import { SendKeySection } from "./-components/send-key-section";

export const Route = createFileRoute("/_app/sistema/")({
	component: SistemaPage,
});

function SistemaPage() {
	return (
		<PageContainer>
			<PageHeader title={SystemLabels.pageTitle} description={SystemLabels.pageDescription} />

			<div className="flex flex-col gap-4">
				<SendKeySection />
				<GuidanceSection />

				<div className="grid gap-4 lg:grid-cols-2">
					<IntegrationsSection />

					<JobsSection />
				</div>

				<div className="grid gap-4 lg:grid-cols-2">
					<AuditSection />

					<DecisionsSection />
				</div>

				<div className="grid gap-4 lg:grid-cols-2">
					<DocumentFieldsSection />

					<EtlSection />
				</div>

				<div className="grid gap-4 lg:grid-cols-2">
					<DocumentProfileSection />

					<DocumentPoliciesSection />
				</div>
			</div>
		</PageContainer>
	);
}
